export const path = "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z";
//export const props = { viewBox: "0 0 12 6", "stroke-width": 2, stroke: "currentcolor", style: "fill:none" }
